export const LanguageKeys = {
  onboarding: {
    email: "emailStep",
    name: "nameStep",
    height: "heightStep",
    gender: "genderStep",
    heading: "onboarding",
  },
  noValidSteps: "noValidSteps",
  unsupportedStep: "unsupportedStep",
  enterEmail: "enterEmail",
  next: "next",
  validEmail: "validEmail",
  emailRequired: "emailRequired",
  nameRequired: "nameRequired",
  enterName: "enterName",
  mens: "mens",
  womens: "womens",
  height: "height",
  heightInInch: "heightInInch",
  heightInFt: "heightInFt",
  heightError: "heightError",
  cmMeasurementUnit: "cmMeasurementUnit",
  ftMeasurementUnit: "ftMeasurementUnit",
  bodyScan: "bodyScan",
  bodyScanDescription: "bodyScanDescription",
  faceScan: "faceScan",
  faceScanDescription: "faceScanDescription",
  sizeFit: "sizeFit",
  readyToStart: "readyToStart",
  readyToStartDescription: "readyToStartDescription",
  turnUpVolume: "turnUpVolume",
  continue: "continue",
  phonePlacement: "phonePlacement",
  phonePlacementDescription: "phonePlacementDescription",
  welcome: "welcome",
  phoneModel: "phoneModel",
  selectPhoneBrand: "selectPhoneBrand",
  selectPhoneModel: "selectPhoneModel",
  reset: "reset",
  loading: "loading",
  start: "start",
  faceVisible: "faceVisible",
  loadingVideo: "loadingVideo",
  videoLoadFailed: "videoLoadFailed",
  scanFailed: "scanFailed",
  resetScan: "resetScan",
  clickToResetScan: "clickToResetScan",
  faceFront: "faceFront",
  faceLeft: "faceLeft",
  faceRight: "faceRight",
  faceSmile: "faceSmile",
  setting: "setting",
  scanStatus: "scanStatus",
  startScan: "startScan",
  cameraAlreadyInUse: "cameraAlreadyInUse",
  tryClosingBrowser: "tryClosingBrowser",
  checkCameraSettings: "checkCameraSettings",
  enableCameraPermissions: "enableCameraPermissions",
  pause: "pause",
  restart: "restart",
  startLevelCheck: "startLevelCheck",
  placePhoneUpright: "placePhoneUpright",
  leavePhone: "leavePhone",
  measurementsBeingTaken: "measurementsBeingTaken",
  serverAtCapacity: "serverAtCapacity",
  serverAtCapacityDescription: "serverAtCapacityDescription",
  issueWithScan: "issueWithScan",
  reason: "reason",
  scanAgain: "scanAgain",
  Custom_Scan: "Custom_Scan",
  Find_your_perfect_fit: "Find_your_perfect_fit",
  One_time_setup_in_2_min_or_less: "One_time_setup_in_2_min_or_less",
  PRIVACY: "PRIVACY",
  Swan_encrypts_your_data_with_Ever_vault_and_ensures_your_video_is_not_seen_by_anyone:
    "Swan_encrypts_your_data_with_Ever_vault_and_ensures_your_video_is_not_seen_by_anyone",
  By_ticking_this_box_you_are_agreeing_to_our:
    "By_ticking_this_box_you_are_agreeing_to_our",
  privacy_policy: "privacy_policy",
  Get_Measured: "Get_Measured",
  Login: "Login",
  Where_do_you_shop: "Where_do_you_shop",
  Men_s: "Men_s",
  Women_s: "Women_s",
  Next: "Next",
  Preferred_language: "Preferred_language",
  Hindi: "Hindi",
  English: "English",
  French: "French",
  Spanish: "Spanish",
  German: "German",
  Italian: "Italian",
  Arabic: "Arabic",
  Phone_Model: "Phone_Model",
  Select_phone_brand: "Select_phone_brand",
  Select_phone_model: "Select_phone_model",
  Measurement_tips: "Measurement_tips",
  Tips_for_your_scan: "Tips_for_your_scan",
  Watch_this_video_to_know_how_to_scan: "Watch_this_video_to_know_how_to_scan",
  How_to_use_Swan: "How_to_use_Swan",
  Watch_this_short_video_to_know_how_to_use:
    "Watch_this_short_video_to_know_how_to_use",
  Shop: "Shop",
  Skip: "Skip",
  Form_fitting_clothing: "Form_fitting_clothing",
  How_form_is_fitting_your_outfit: "How_form_is_fitting_your_outfit",
  For_accurate_scan_please_wear_tight_clothing_Here_s_an_example:
    "For_accurate_scan_please_wear_tight_clothing_Here_s_an_example",
  Scan_with_form_fitting: "Scan_with_form_fitting",
  Scan_with_form_loose_fit: "Scan_with_form_loose_fit",
  Turn_up_your_volume: "Turn_up_your_volume",
  For_smart_voice_guide: "For_smart_voice_guide",
  Place_your_phone_on_a_table_at: "Place_your_phone_on_a_table_at",
  a_hip_height: "a_hip_height",
  Scan: "Scan",
  Height: "Height",
  Height_in_ft: "Height_in_ft",
  Height_in_inch: "Height_in_inch",
  How_tall_are_you: "How_tall_are_you",
  We_are_sorry_we_currently_do_not_support_this_heights_outside_of_5_ft_and_7_ft_We_are_working_on_new_models_that_do:
    "We_are_sorry_we_currently_do_not_support_this_heights_outside_of_5_ft_and_7_ft_We_are_working_on_new_models_that_do",
  Confirm: "Confirm",
  To_start_your_measurement: "To_start_your_measurement",
  Scan_this_QR_code_with_your_phone: "Scan_this_QR_code_with_your_phone",
  You_can_continue_from_here_after_your_scan:
    "You_can_continue_from_here_after_your_scan",
  Failed_to_get_measurements: "Failed_to_get_measurements",
  No_data_found_Go_back_to: "No_data_found_Go_back_to",
  back: "back",
  Profile: "Profile",
  shopify: "shopify",
  fit_view_result: "fit_view_result",
  Nest: "Nest",
  Scan_again: "Scan_again",
  Provide_feedback: "Provide_feedback",
  Add_to_cart: "Add_to_cart",
  Back_to_product: "Back_to_product",
  Fit_Notes: "Fit_Notes",
  Fitted: "Fitted",
  Ideal_fit: "Ideal_fit",
  Relaxed: "Relaxed",
  Wrong_email_format: "Wrong_email_format",
  Something_went_wrong: "Something_went_wrong",
  Email_is_required: "Email_is_required",
  Scan_status: "Scan_status",
  Uploading: "Uploading",
  Processing: "Processing",
  Finishing: "Finishing",
  Complete: "Complete",
  You_re_logged_in: "You_re_logged_in",
  Swan_will_load_on_every_supported_page:
    "Swan_will_load_on_every_supported_page",
  Happy_Shopping: "Happy_Shopping",
  Email_verification_failed: "Email_verification_failed",
  Email_Confirmed: "Email_Confirmed",
  Measurements_saved: "Measurements_saved",
  Login_anywhere_you_see_the_Swan_logo_to_load_your_measurements:
    "Login_anywhere_you_see_the_Swan_logo_to_load_your_measurements",
  Check_your_email: "Check_your_email",
  Tap_on_the_verification_link_sent_to: "Tap_on_the_verification_link_sent_to",
  Email_Confirmation: "Email_Confirmation",
  Save_your_scan: "Save_your_scan",
  Confirm_with_a_single_tap_from_your_email_inbox:
    "Confirm_with_a_single_tap_from_your_email_inbox",
  Saving_your_scan_means_you_can_load_your_measurements_anywhere_you_see_the_Swan_logo:
    "Saving_your_scan_means_you_can_load_your_measurements_anywhere_you_see_the_Swan_logo",
  Passwordless_Just_one_tap_via_email: "Passwordless_Just_one_tap_via_email",
  Join_2000_shoppers: "Join_2000_shoppers",
  Your_measurements_will_be_shared_only_once_your_email_is_confirmed:
    "Your_measurements_will_be_shared_only_once_your_email_is_confirmed",
  Enter_your_email: "Enter_your_email",
  Send_confirmation_email: "Send_confirmation_email",
  No_thanks: "No_thanks",
  We_are_sorry: "We're_sorry",
  Video_tips_for_scanning: "Video_tips_for_scanning",
  Please_make_sure_to: "Please_make_sure_to",
  one_Complete_a_full_spin_Starting_and_finishing_with_your_feet_facing_your_phone:
    "one_Complete_a_full_spin_Starting_and_finishing_with_your_feet_facing_your_phone",
  two_Rotate_slowly_throughout_your_spin:
    "two_Rotate_slowly_throughout_your_spin",
  three_Make_sure_your_full_body_including_feet_and_hands_are_visible_in_frame:
    "three_Make_sure_your_full_body_including_feet_and_hands_are_visible_in_frame",
  Scan_s: "Scan_s",
  vision_model: "vision_model",
  is_at_capacity: "is_at_capacity",
  We_are_sorry_about_this_We_are_working_hard_to_add_capacity_Please_try_again_soon:
    "We_are_sorry_about_this_We_are_working_hard_to_add_capacity_Please_try_again_soon",
  Oops: "Oops",
  Looks_like_this_QR_code_is_not_valid: "Looks_like_this_QR_code_is_not_valid",
  Reload_your_desktop_tab_to_generate_a_new_code:
    "Reload_your_desktop_tab_to_generate_a_new_code",
  Magic_link: "Magic_link",
  We_have_sent_you_a_magic_link_via_email:
    "We_have_sent_you_a_magic_link_via_email",
  Please_confirm_your_email_load_your_measurements_on_any_partner_brand:
    "Please_confirm_your_email_load_your_measurements_on_any_partner_brand",
  Welcome_back: "Welcome_back",
  Load_my_account: "Load_my_account",
  Back_to_home: "Back_to_home",
  Enter_a_valid_email: "Enter_a_valid_email",
  No_measurement_found_for_this_email: "No_measurement_found_for_this_email",
  Reset: "Reset",
  Resume: "Resume",
  Start_Scan: "Start_Scan",
  Scanning: "Scanning",
  Detecting_Body: "Detecting_Body",
  Stop: "Stop",
  Generating_Measurements: "Generating_Measurements",
  Help: "Help",
  Scan_tips: "Scan_tips",
  Watch_instructions_video: "Watch_instructions_video",
  Wear_form_fitting_clothing_for_the_most_accurate_results:
    "Wear_form_fitting_clothing_for_the_most_accurate_results",
  Position_yourself_in_a_brightly_lit_room:
    "Position_yourself_in_a_brightly_lit_room",
  Tie_up_long_hair_and_slip_off_your_shoes:
    "Tie_up_long_hair_and_slip_off_your_shoes",
  Back: "Back",
  Swan: "Swan",
  Please_check_your_setting_for_camera_permission:
    "Please_check_your_setting_for_camera_permission",
  Settings: "Settings",
  Enable_the_camera_permissions: "Enable_the_camera_permissions",
  Go_Back: "Go_Back",
  Measurements_have_been_shared: "Measurements_have_been_shared",
  For_helping_in_getting: "For_helping_in_getting",
  Thank_You: "Thank_You",
  live: "live",
  Your: "Your",
  Check_back_soon_to_use_Swan: "Check_back_soon_to_use_Swan",
  custom_for_your_next_order: "custom_for_your_next_order",
  sevenTillEight: "7till8",
  Rhodes_and_Beckett: "Rhodes_and_Beckett",
  Send_invite: "Send_invite",
  Your_Nest: "Your_Nest",
  Share_your_measurements_to_shop_and_gift_for_those_close_to_you:
    "Share_your_measurements_to_shop_and_gift_for_those_close_to_you",
  Invite_to_Swan: "Invite_to_Swan",
  Name: "Name",
  Enter_their_name: "Enter_their_name",
  Enter_their_email: "Enter_their_email",
  Message: "Message",
  Join_Swan: "Join_Swan",
  Email: "Email",
  Invite: "Invite",
  Your_Login: "Your_Login",
  Your_Scans: "Your_Scans",
  Talk_with_the_CEO: "Talk_with_the_CEO",
  Send_me_an_email: "Send_me_an_email",
  At_Swan_we_are_here_to_make_shopping_about_you_I_would_love_to_hear_what_you_think_of_Swan_and_what_you_want_to_see_next_I_am_excited_to_hear_your_feedback:
    "At_Swan_we_are_here_to_make_shopping_about_you_I_would_love_to_hear_what_you_think_of_Swan_and_what_you_want_to_see_next_I_am_excited_to_hear_your_feedback",
  Eoin: "Eoin",
  You_can_close_this_tab_and_return_to_the_original_to_get_your_sizing_suggestion:
    "You_can_close_this_tab_and_return_to_the_original_to_get_your_sizing_suggestion",
  Try_On: "Try_On",
  Invite_friends: "Invite_friends",
  Pending: "Pending",
  Decline: "Decline",
  gifting_simple: "gifting_simple",
  Invite_friends_and_make: "Invite_friends_and_make",
  Nest_will_be_able_to_see_and_size_clothes_on_you:
    "Nest_will_be_able_to_see_and_size_clothes_on_you",
  By_sharing_your_Swan_profile_those_in_your:
    "By_sharing_your_Swan_profile_those_in_your",
  Enter_your_name: "Enter_your_name",
  Failed_to_get_tryon: "Failed_to_get_tryon",
  In_Progress: "In_Progress",
  Go_back_to: "Go_back_to",
};
